import { call, put, takeEvery } from "redux-saga/effects";
import { getRateCard } from "redux/actions/UserRateCard";
import { onLoaderTrigger } from "redux/actions/commonAction";
import store from "redux/store";
import { GET_CAR, GET_CARFACILTIES } from "resources/actionTypes";
import { carApi, carFacilities } from "services/CarService";

function* fetchCar(action) {
  const payload = action.payload || {}
  const userCar = yield call(carApi, payload?.data);

  if (userCar?.success) {
    yield put({ type: GET_CAR.GET_CAR_SUCCESS, userCar: userCar });

    if (payload?.type) {
      const payloadData = {
        ...payload?.data,
        carType: userCar?.data?.[0]?.id
      }

      const carType = userCar?.data?.map((val) => ({
        id: val.id,
        name: val.carType,
      }));

      const filterValues = {
        ...payload?.filterValues,
        carType: carType?.[0]
      }
      payload?.setFilterValues(filterValues)
      store.dispatch(getRateCard(payloadData))
    }

  } else {
    yield put({ type: GET_CAR.GET_CAR_FAILED, message: userCar?.message });
  }
}

export function* carSagaWatcher() {
  yield takeEvery(GET_CAR.GET_CAR_REQUESTED, fetchCar);
}


function* fetchCarFacilities(action) {
  store.dispatch(onLoaderTrigger(true));
    const payload = action.payload || {}
    const userCarFacilities = yield call(carFacilities, payload?.data);

    if (userCarFacilities?.success) {
      yield put({ type: GET_CARFACILTIES.GET_CARFACILTIES_SUCCESS, userCarFacilities: userCarFacilities })
    } else {
      yield put({ type:GET_CARFACILTIES.GET_CARFACILTIES_FAILED, message: userCarFacilities?.message });
    }

    store.dispatch(onLoaderTrigger(false));

}

export function* carFacilitiesSaga() {
  yield takeEvery(GET_CARFACILTIES.GET_CARFACILTIES_REQUESTED, fetchCarFacilities);
}